import {
  RouterModule,
  Routes,
} from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ClaimsComponent } from './claims/claims.component';
import { LogoutComponent } from './logout/logout.component';
import {
  MsalGuard,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'claims',
    component: ClaimsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'auth',
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/redirects.md
    component: MsalRedirectComponent
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
